import { createContext, useContext, useEffect, useState } from "react";

// Teme de culoare (Premium). Fiecare setează accentul principal al aplicației.
export const THEMES = [
  { id: "emerald", label: "Verde", brand: "#059669", brand600: "#059669", brand700: "#047857", soft: "#d1fae5", softText: "#047857" },
  { id: "ocean", label: "Ocean", brand: "#0284c7", brand600: "#0284c7", brand700: "#0369a1", soft: "#e0f2fe", softText: "#0369a1" },
  { id: "grape", label: "Mov", brand: "#7c3aed", brand600: "#7c3aed", brand700: "#6d28d9", soft: "#ede9fe", softText: "#6d28d9" },
  { id: "sunset", label: "Apus", brand: "#ea580c", brand600: "#ea580c", brand700: "#c2410c", soft: "#ffedd5", softText: "#c2410c" },
];

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

function applyTheme(id) {
  const t = THEMES.find((x) => x.id === id) || THEMES[0];
  const root = document.documentElement;
  root.style.setProperty("--brand", t.brand);
  root.style.setProperty("--brand-700", t.brand700);
  root.style.setProperty("--brand-soft", t.soft);
  root.style.setProperty("--brand-soft-text", t.softText);
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(
    () => localStorage.getItem("chit_theme") || "emerald"
  );

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = (id) => {
    localStorage.setItem("chit_theme", id);
    setThemeState(id);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
